import GreeterRoot from "./greeter"
import Sub from "./sub"
import Title from "./title"

const GreeterUI = Object.assign(GreeterRoot, {
  Sub,
  Title,
})

export default GreeterUI
